<div class="tree default" *ngIf="advisoryCompanies">
  <div class="items">
    <advisories-tree-company [advisoryCompany]="advisoryCompany" *ngFor="let advisoryCompany of advisoryCompanies"></advisories-tree-company>
    <div class="none" *ngIf="!advisoryCompanies.length">Организация не является членом ТК или ПК</div>
  </div>
</div>
